import React from "react";
import ModalNew from "./ModalNew";
import { Loader2 } from "lucide-react";

interface PdfPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string | null;
  onSubmit: () => void;
  isSubmitting: boolean;
  title?: string;
  submitButtonText?: string;
}

const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
  isOpen,
  onClose,
  pdfUrl,
  onSubmit,
  isSubmitting,
  title = "Document Preview",
  submitButtonText = "Submit",
}) => {
  return (
    <ModalNew
      isOpen={isOpen}
      onClose={onClose}
      className="!max-w-[900px] !w-[90vw]"
    >
      <div className="flex flex-col h-[80vh]">
        {/* Header */}
        <div className="flex items-center justify-between pb-3 border-b border-gray-200 mb-3">
          <h2 className="text-xl font-bold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors text-2xl leading-none"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 min-h-0 bg-gray-100 rounded-lg overflow-hidden">
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              className="w-full h-full border-0 rounded-lg"
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center text-gray-500">
                <Loader2 className="w-10 h-10 animate-spin mx-auto mb-3 text-primary" />
                <p>Generating preview…</p>
              </div>
            </div>
          )}
        </div>

        {/* Footer with Submit */}
        <div className="pt-4 flex justify-center">
          <button
            onClick={onSubmit}
            disabled={isSubmitting || !pdfUrl}
            className={`px-10 py-3 rounded-lg font-semibold text-white transition-all min-w-[200px] flex items-center justify-center gap-2 ${
              isSubmitting || !pdfUrl
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-primary hover:bg-primary/90 shadow-md hover:shadow-lg"
            }`}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Submitting…
              </>
            ) : (
              submitButtonText
            )}
          </button>
        </div>
      </div>
    </ModalNew>
  );
};

export default PdfPreviewModal;
